<template>
  <div class="top-ten-stat-card-container">
    <div class="stat-card-header">
      <div class="title">
          {{ $t('navbar.stats_average') }}
      </div>
      <div class="mode-slider">
        <div
          @click="mode = 'menus'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'menus' }"
        >
          {{ $t('stats_histogram.menus')}}
        </div>
        <div
          @click="mode = 'sections'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'sections' }"
        >
          {{ $t('stats_histogram.sections')}}
        </div>
      </div>
    </div>
    <div class="list-container">
      <div class="list">
        <div v-for="entry in dataset" :key="entry.label" class="list-row">
          <div>{{entry.label}}</div>
          <div class="c-green">{{entry.value}}{{currency.symbol}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    DashboardButton,
  },
  props: {
    menus: Array,
    sections: Array
  },
  data() {
      return {
        mode: 'menus'
      }
  },
  computed: {
    dataset() {
        return this.mode == 'menus' ? this.menus : this.sections;
    },
    currency() {
        return this.$store.state.currency;
    }
  }
};
</script>
<style scoped>
.top-ten-stat-card-container {
  width: 100%;
  background: #e5e5e5;
  border-radius: 1.3333333333333333vh;
  padding: 2.222vh;
  margin-top: 3.3333vh;
  box-sizing: border-box;
}
.stat-card-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
}
.list-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.list {
  width: calc(100% - 1.1111vh);
}
.list-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.1111vh;
  font-size: 2.222vh;
  line-height: 2.5555vh;
  color: #908f8d;
}
.list-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2.222vh;
  line-height: 2.5555vh;
  color: #1d1d1b;
  padding: 0.555vh;
  border-bottom: 0.111vh solid #908f8d;
}
.list-row:hover {
  color: #ededed;
  background: #129b81;
}
.list-row:last-child {
  border: none;
}
.mode-slider {
  height: 3.666h;
  background: #ededed;
  border-radius: 0.444vh;
  display: flex;
}
.mode-slide-btn {
  width: 26.22222222222222vh;
  height: 3.666vh;
  border-radius: 0.444vh;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active-mode {
  background: #1d1d1b;
  color: #ededed;
}
</style>
